import React from 'react';
// import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-black-900 text-white flex flex-col items-center justify-center p-4">
      <h1 className="text-4xl font-bold mb-4 font-serif">Page Temporarily Disabled</h1>
      <p className="text-lg text-black-300">This page is currently unavailable.</p>
    </div>
  );
  /*
  return (
    <div className="min-h-screen bg-white pt-16">
      <section className="pt-20 pb-16 bg-gradient-to-br from-black-900 to-black-800 text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-6xl font-bold text-center">Privacy Policy</h1>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose lg:prose-xl">
            <h2>Introduction</h2>
            <p>
              Your privacy is important to us. This privacy policy explains how we collect, use, and protect your personal information.
            </p>
            <h2>Information We Collect</h2>
            <p>
              We may collect personal information such as your name, email address, and payment information when you register for our courses.
            </p>
            <h2>How We Use Your Information</h2>
            <p>
              We use your information to provide and improve our services, process payments, and communicate with you.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
  */
};

export default PrivacyPolicy;